var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.727 0H3.273C2.40527 0.00105853 1.57339 0.346231 0.959809 0.959809C0.346231 1.57339 0.00105853 2.40527 0 3.273V20.727C0.00105853 21.5947 0.346231 22.4266 0.959809 23.0402C1.57339 23.6538 2.40527 23.9989 3.273 24H20.727C21.5946 23.9987 22.4264 23.6534 23.0399 23.0399C23.6534 22.4264 23.9987 21.5946 24 20.727V3.273C23.9989 2.40527 23.6538 1.57339 23.0402 0.959809C22.4266 0.346231 21.5947 0.00105853 20.727 0ZM22.909 20.727C22.9072 21.3051 22.6767 21.8591 22.2679 22.2679C21.8591 22.6767 21.3051 22.9072 20.727 22.909H3.273C2.69487 22.9072 2.14094 22.6767 1.73213 22.2679C1.32333 21.8591 1.09285 21.3051 1.091 20.727V3.273C1.09285 2.69487 1.32333 2.14094 1.73213 1.73213C2.14094 1.32333 2.69487 1.09285 3.273 1.091H20.727C21.3051 1.09285 21.8591 1.32333 22.2679 1.73213C22.6767 2.14094 22.9072 2.69487 22.909 3.273V20.727Z",
    fill: "#99A3AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.783 4.948C7.35848 4.948 7.825 4.48148 7.825 3.906C7.825 3.33052 7.35848 2.864 6.783 2.864C6.20752 2.864 5.741 3.33052 5.741 3.906C5.741 4.48148 6.20752 4.948 6.783 4.948Z",
    fill: "#99A3AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.948C12.5755 4.948 13.042 4.48148 13.042 3.906C13.042 3.33052 12.5755 2.864 12 2.864C11.4245 2.864 10.958 3.33052 10.958 3.906C10.958 4.48148 11.4245 4.948 12 4.948Z",
    fill: "#99A3AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.218 4.948C17.7935 4.948 18.26 4.48148 18.26 3.906C18.26 3.33052 17.7935 2.864 17.218 2.864C16.6425 2.864 16.176 3.33052 16.176 3.906C16.176 4.48148 16.6425 4.948 17.218 4.948Z",
    fill: "#99A3AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.934 9.217H11.694V12.562H7.934V9.217Z",
    fill: "#99A3AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.307 9.217H16.067V12.562H12.307V9.217Z",
    fill: "#99A3AD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.677 9.217H20.437V12.562H16.677V9.217Z",
    fill: "#99A3AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.563 13.116H7.323V16.459H3.563V13.116Z",
    fill: "#99A3AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.934 13.116H11.694V16.459H7.934V13.116Z",
    fill: "#99A3AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.307 13.116H16.067V16.459H12.307V13.116Z",
    fill: "#99A3AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.677 13.116H20.437V16.459H16.677V13.116Z",
    fill: "#99A3AD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.563 17.015H7.323V20.358H3.563V17.015Z",
    fill: "#99A3AD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.934 17.015H11.694V20.358H7.934V17.015Z",
    fill: "#99A3AD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.307 17.015H16.067V20.358H12.307V17.015Z",
    fill: "#99A3AD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.677 17.015H20.437V20.358H16.677V17.015Z",
    fill: "#99A3AD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.a222cad8e24c524441c175eacecb93ad.svg";
export { ForwardRef as ReactComponent };